import { trackSetCheckoutOption } from '../../../../../../shared/analytics/e-commerce/trackSetCheckoutOption';
import { CreditCardType } from '../../../../../../payment/domain/models';
import { NewBooking } from '../../../../../domain/booking/models/NewBooking';
import { adaptNewBookingToItems } from './adapters/adaptNewBookingToItems';

interface IPaymentMethod {
	isNewCard: boolean;
	cardType: CreditCardType;
	booking: NewBooking;
}

export function trackPaymentMethod({
	isNewCard,
	cardType,
	booking,
}: IPaymentMethod) {
	const items = adaptNewBookingToItems(booking) ?? [];

	trackSetCheckoutOption({
		isNewCard,
		cardType,
		items,
	});
}
